var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "filmstrip" },
    [
      _vm.title
        ? _c("h3", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))])
        : _vm._e(),
      _vm.contents.length > 0
        ? _c(
            "div",
            { staticClass: "content" },
            [
              _c(
                "carousel",
                {
                  attrs: {
                    "per-page": 1,
                    "per-page-custom": [
                      [540, 2],
                      [780, 3],
                      [1020, 4],
                      [1220, 5],
                      [1500, 6],
                      [2740, 7],
                      [1980, 8],
                      [2220, 9],
                      [2460, 11],
                      [2700, 12],
                    ],
                    "navigation-enabled": true,
                    "pagination-enabled": false,
                    "scroll-per-page": false,
                  },
                },
                [
                  _vm._l(_vm.contents, function (item, index) {
                    return _c(
                      "slide",
                      { key: index },
                      [
                        _c(
                          "b-card",
                          {
                            staticClass: "item",
                            class: [
                              { current: item.id == _vm.current },
                              _vm.cardClasses(item),
                            ],
                            attrs: {
                              title: item.title ? item.title.rendered : "",
                              "img-src": item.thumbnail,
                              "img-top": "",
                            },
                          },
                          [
                            _c("p", {
                              staticClass: "card-text",
                              domProps: {
                                innerHTML: _vm._s(
                                  item.content
                                    ? item.content.rendered
                                    : item.caption
                                    ? item.caption.rendered
                                    : ""
                                ),
                              },
                            }),
                            item.id == _vm.current
                              ? _c(
                                  "b-btn",
                                  {
                                    directives: [
                                      {
                                        name: "scroll-to",
                                        rawName: "v-scroll-to",
                                        value: {
                                          el: "#featured",
                                          container: ".page",
                                          x: false,
                                          y: true,
                                        },
                                        expression:
                                          "{ el: '#featured', container: '.page',\n                              x: false, y: true }",
                                      },
                                    ],
                                    staticClass: "float-right watching",
                                    attrs: { variant: "link", size: "lg" },
                                  },
                                  [
                                    _vm._v(
                                      "now " +
                                        _vm._s(_vm.sayAction(item)) +
                                        "ing"
                                    ),
                                  ]
                                )
                              : _c("watch-button", { attrs: { target: item } }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _c("div", {
                    staticClass: "swiper-button-prev",
                    attrs: { slot: "button-prev" },
                    slot: "button-prev",
                  }),
                  _c("div", {
                    staticClass: "swiper-button-next",
                    attrs: { slot: "button-next" },
                    slot: "button-next",
                  }),
                  _c("div", {
                    staticClass: "swiper-scrollbar",
                    attrs: { slot: "scrollbar" },
                    slot: "scrollbar",
                  }),
                ],
                2
              ),
            ],
            1
          )
        : [
            _c("div", { staticClass: "message empty-list" }, [
              _vm._v("nothing to show yet"),
            ]),
            _vm.query
              ? _c(
                  "a",
                  {
                    staticClass: "loadmore",
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.loadMore.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("refresh")]
                )
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }